export default __webpack_public_path__ + "static/Ellipse 4-764648f101ddcbe6be1adf67c3d70197.png";